import * as React from 'react';
import clsx from 'clsx';
import { ListContext } from '../context';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "List-root_1rtA8",
  "default": "List-default_2WjzD",
  "compact": "List-compact_NRUsh",
  "bordered": "List-bordered_1gGDc"
};
function defaultItemId(item) {
  const key = item.uuid || item.id;
  if (!key) {
    return undefined;
  }
  return String(key);
}
function List({
  items,
  itemId = defaultItemId,
  render,
  children,
  variant = 'default',
  className,
  classes,
  ...extraProps
}) {
  const classOf = key => classes?.[key] ?? '';
  const renderChildren = (item, index) => {
    if (typeof render === 'function') {
      return render(item, index);
    }
    if (typeof children === 'function') {
      return children(item, index);
    }
    return null;
  };
  const rootClasses = clsx(styles.root, className, classOf('list'));
  const itemClass = clsx(styles.item, styles[variant], classOf('item'));
  const context = React.useMemo(() => ({
    variant
  }), [variant]);
  return /*#__PURE__*/_jsx("ul", {
    className: rootClasses,
    ...extraProps,
    children: /*#__PURE__*/_jsx(ListContext.Provider, {
      value: context,
      children: items.map((item, i) => /*#__PURE__*/_jsx("li", {
        className: itemClass,
        children: renderChildren(item, i)
      }, itemId(item, i)))
    })
  });
}
export default List;